// removed by extract-text-webpack-plugin
module.exports = {"NewPurchase":"NewPurchase__NewPurchase__3JDxV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Tracker/NewPurchase/NewPurchase.css
// module id = 70
// module chunks = 0